import { useCallback, useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";

// Shared by the org catalog/members/setup pages: fetch the org + the caller's role once per slug.
export function useOrg(slug) {
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    if (!slug) return;
    setLoading(true);
    try {
      const { data } = await api.get(`/orgs/${slug}`);
      setOrg(data);
      setError(null);
    } catch (e) {
      setError(apiErr(e, "Could not load this org"));
    } finally {
      setLoading(false);
    }
  }, [slug]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { org, loading, error, reload };
}
